export const gateway = "https://qat-greengardens-bms-api.link-nonprod.wawanesalife.com";
export const LoginUrlParameter = "https://qat-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=3388huep022vgfnj6qnvif2n9i&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fqat-greengardens-bms.link-nonprod.wawanesalife.com%2Fredirect";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "3388huep022vgfnj6qnvif2n9i";
export const BrokerPoolDomainParameter = "qat-brokers";
export const BrokerPoolParameter = "ca-central-1_f0PTGfA8O";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://qat-greengardens-shopper.link-nonprod.wawanesalife.com";

//updated on Thu Jul 23 2026 12:16:47 GMT-0500 (Central Daylight Time)
